import type { TopUpBundle } from '../../lib/top-up-bundles';
import { formatPrice } from '../../lib/top-up-bundles';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

export interface TopUpBundleCardProps {
  bundle: TopUpBundle;
  onSelect: (bundleId: string) => void;
  isPending: boolean;
  badge?: string | undefined;
  disabled?: boolean;
}

export function TopUpBundleCard({
  bundle,
  onSelect,
  isPending,
  badge,
  disabled = false,
}: TopUpBundleCardProps): JSX.Element {
  return (
    <Card
      data-testid={`topup-bundle-${bundle.id}`}
      className="relative flex flex-col items-center p-4 pt-8 gap-2"
    >
      {badge ? (
        <Badge
          variant="outline"
          className="absolute top-2 right-2 text-micro"
        >
          {badge}
        </Badge>
      ) : null}
      <div className="text-h2 font-bold tabular-nums">
        {bundle.points.toLocaleString()}
      </div>
      <div className="text-small text-text-2">points</div>
      {bundle.bonus_pct > 0 ? (
        <div className="text-small text-accent-pull">
          +{bundle.bonus_pct}% bonus
        </div>
      ) : null}
      <div className="text-body font-semibold tabular-nums">
        {formatPrice(bundle.price_cents)}
      </div>
      <Button
        onClick={() => onSelect(bundle.id)}
        disabled={disabled || isPending}
        data-testid={`topup-buy-${bundle.id}`}
        className="w-full"
      >
        {isPending ? 'Processing...' : 'Top Up'}
      </Button>
    </Card>
  );
}
